import { render } from "./BottomGradient.vue?vue&type=template&id=2442ac22&scoped=true"
import script from "./BottomGradient.vue?vue&type=script&lang=js"
export * from "./BottomGradient.vue?vue&type=script&lang=js"

import "./BottomGradient.vue?vue&type=style&index=0&id=2442ac22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2442ac22"]])

export default __exports__